export default __webpack_public_path__ + "static/media/poll_icon_grey.948ddbd5.svg";